import React, { Component } from 'react';
import { withRouter, Link } from 'react-router'
import Constants from '../Constants.js';
import Cookies from 'cookies-js';

class Logout extends Component {

  // constructor(props) {
  //   super(props);
  // }

  render() {
    Cookies.expire('jwtsession');

    return (
    	<div>
	      <div style={{'textAlign': 'center', padding: '40px 15px', 'marginTop': '10%'}}>
	      	<div className="lead">
		        You have been logged out.

		        <br/>
            <Link to={`${Constants.APP_URL_PREFIX}/login`}>
                Login
            </Link>  

		       </div>
	      </div>
    	</div>

    );
  }
}

export default withRouter(Logout);


// WEBPACK FOOTER //
// ./src/components/auth/Logout.js